import type { VoidFunctionComponent } from 'react';

import { SNIPPET_DETECTION } from '../../../../shared/featureFlags/flagNames';
import { LabeledCheckbox } from '../../generic';
import FeatureFlagRequired from '../../generic/Gates/FeatureFlagRequired';

import Section from './SettingsPageSection';

type SnippetScanningSettingsSectionProps = {
  /** Current state of snippet scanning */
  isSnippetScanningEnabled: boolean;
  /** Callback when checkbox is toggled */
  onToggleSnippetScanning: (isChecked: boolean) => void;
  /** Whether main scanning is enabled */
  isScanningEnabled: boolean;
  /** User permission to edit policy */
  canEditPolicy: boolean;
  /** Type of scanning ('security' or 'license') */
  scanType: 'security' | 'license';
};

/**
 * SnippetScanningSettingsSection
 *
 * Renders a checkbox control for enabling/disabling snippet scanning
 * with context-appropriate messaging based on scan type.
 * The component is only visible when the SNIPPET_DETECTION feature flag is enabled.
 */
const SnippetScanningSettingsSection: VoidFunctionComponent<SnippetScanningSettingsSectionProps> = ({
  isSnippetScanningEnabled,
  onToggleSnippetScanning,
  isScanningEnabled,
  canEditPolicy,
  scanType,
}) => {
  return (
    <FeatureFlagRequired flagName={SNIPPET_DETECTION}>
      <LabeledCheckbox
        label="Enable snippet issue scanning"
        isChecked={isSnippetScanningEnabled}
        onChange={(_, isChecked) => onToggleSnippetScanning(isChecked)}
        isDisabled={!canEditPolicy || !isScanningEnabled}
      />
      <Section.Paragraph>
        Enabling this will turn on {scanType} issue scanning for this project&apos;s
        snippets.
      </Section.Paragraph>
    </FeatureFlagRequired>
  );
};

export default SnippetScanningSettingsSection;
